module.exports = __webpack_public_path__ + "img/yhlTitle.fcb82359.svg";